// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Yeq4","rootSmall":"AddTileButton_rootSmall__wCNJ7"};